import useSWR from "swr";
import axios from "axios";

function useDocumentTypes({ page, perPage, showArchived }) {
  const url = `${process.env.REACT_APP_API_URL}/document-types`;

  return useSWR(
    [url, page, perPage, showArchived],
    async ([url, page, perPage, showArchived]) => {
      const params = new URLSearchParams();

      if (page) params.append('page', page);
      if (perPage) params.append('perPage', perPage);
      if (showArchived) params.append('showArchived', showArchived);

      const { data: { documentTypes, count } } = await axios.get(`${url}?${params.toString()}`);

      return { documentTypes, count };
    });
}

export default useDocumentTypes;
